<form [formGroup]="applyCouponForm" (ngSubmit)="applyAction()">
        <div class="container-fluid">
            <div class="modal-content">
                <div class="row d-flex align-items-center add-new-tam-container">
                    <div class="col s10 add-new-team-contain">
                        <h1>Apply coupon</h1>
                    </div>
       
                    <div class="col s2">
                        <span [mat-dialog-close]="true" class="close-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <path
                                    d="M20.0002 3.33398C10.7835 3.33398 3.3335 10.784 3.3335 20.0007C3.3335 29.2173 10.7835 36.6673 20.0002 36.6673C29.2168 36.6673 36.6668 29.2173 36.6668 20.0007C36.6668 10.784 29.2168 3.33398 20.0002 3.33398ZM28.3335 25.984L25.9835 28.334L20.0002 22.3507L14.0168 28.334L11.6668 25.984L17.6502 20.0007L11.6668 14.0173L14.0168 11.6673L20.0002 17.6507L25.9835 11.6673L28.3335 14.0173L22.3502 20.0007L28.3335 25.984Z"
                                    fill="#D9D9D9" />
                            </svg>
                        </span>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col s12">
                          <mat-form-field class="mat-form" appearance="outline">
                            <mat-label>Enter coupon</mat-label>
                            <input
                            #data
                              matInput
                              formControlName="coupon"
                              placeholder="Have a coupon code? Apply here"
                              (keyup)="onKey()"
                            />
                          </mat-form-field>
                          <mat-error *ngIf="applyCouponForm.get('coupon')?.hasError('required') && (applyCouponForm.get('coupon')?.dirty || applyCouponForm.get('coupon')?.touched) && !isError">
                            Coupon code is required
                          </mat-error>
                          <mat-error *ngIf="isError">
                            {{errorMsg}}
                          </mat-error>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row btns-row modal-footer">
                <div class="col s12 btns-contain">
                    <button type="submit" mat-stroked-button class="cancel-btn" [disabled]="!applyCouponForm.valid || isError || isloading">Apply
                    </button>
                    <button type="button" mat-raised-button class="delete-btn" [mat-dialog-close]="true">Close
                    </button>
                </div>
            </div>
        </div>
    
</form>

